import { render } from "./UpcomingEventsCalendarCard.vue?vue&type=template&id=05be2e49"
import script from "./UpcomingEventsCalendarCard.vue?vue&type=script&lang=js"
export * from "./UpcomingEventsCalendarCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__